var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGotoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.33013C23.141 1.65064 28.859 1.65063 33.5 4.33013L41.0167 8.66987C45.6577 11.3494 48.5167 16.3013 48.5167 21.6603V30.3397C48.5167 35.6987 45.6577 40.6506 41.0167 43.3301L33.5 47.6699C28.859 50.3494 23.141 50.3494 18.5 47.6699L10.9833 43.3301C6.34232 40.6506 3.48334 35.6987 3.48334 30.3397V21.6603C3.48334 16.3013 6.34232 11.3494 10.9833 8.66987L18.5 4.33013Z",
    fill: "#05C6C5",
    fillOpacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25.5H26M26 25.5L32.3529 32M26 25.5L32.3529 19",
    stroke: "#05C6C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoLight);
export default __webpack_public_path__ + "static/media/gotoLight.92218b4e58f115a8b4552d771316a6b5.svg";
export { ForwardRef as ReactComponent };